import React from 'react';

export default function DiferenciaClaveCallout({ texto }) {
  if (!texto) {
    return null;
  }

  return (
    <div className="mt-8 flex flex-col gap-3 rounded-2xl bg-[#0f172a] p-5 text-white sm:flex-row sm:items-center sm:gap-6">
      <span className="bg-slate-700 text-[10px] font-bold px-3 py-1 rounded uppercase tracking-widest whitespace-nowrap">
        Diferencia Clave
      </span>
      <p className="text-sm font-medium">{texto}</p>
    </div>
  );
}
